<div class="common-container">
  <p class="common-info">Get to know your current tasks of your workspace.</p>
  <div class="action-button-holder">
    <button
      *appRequiredRoles="[
        { role: 'admin', status: ['DRAFTING', 'IN_REVIEW', 'APPROVED'] },
        { role: 'reviewer', status: ['DRAFTING', 'IN_REVIEW'] },
        { role: 'editor', status: 'DRAFTING' }
      ]"
      [matTooltip]="'Add new task'"
      (click)="addNewTask()"
      [disabled]="isDisabledEdit$ | async"
      mat-icon-button>
      <mat-icon>add</mat-icon>
    </button>
    <a class="timeline-button" mat-icon-button [routerLink]="'timeline'" [matTooltip]="'View task timeline'">
      <mat-icon>view_timeline</mat-icon>
    </a>
    @if (loading$ | async) {
      <mat-progress-spinner [diameter]="40" mode="indeterminate"></mat-progress-spinner>
    }
    <a
      mat-icon-button
      [routerLink]="activeView === 'kanban' ? ['list'] : ['kanban']"
      [matTooltip]="activeView === 'kanban' ? 'Switch to List View' : 'Switch to Board View'">
      <mat-icon>{{ activeView === 'kanban' ? 'view_list' : 'view_kanban' }}</mat-icon>
    </a>
  </div>
</div>

<router-outlet></router-outlet>
